<template>
    <Button :label="$t('edit_order')" icon="pi pi-pencil" class="p-button-sm" style="background-color:var(--cyan-700)" @click="onShowMergeModal" />

    <CustomSidebar v-model:visible="showMergeModal" position="bottom" :dismissable="false" :title="editTitle" class="p-1" :blocked="blocked">
        <template #actions>
            <Button icon="pi pi-save" class="p-button mr-1" style="background-color:var(--cyan-700)" :label="$t('edit_order')" @click="save()"></Button>
        </template>
 
        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-3 md-3 p-fluid">
                <div class="p-inputgroup">
                    <CustomChips v-model="addSAPNo" :allowDuplicate="false" :disabled="hasOrder"/>
                    <Button icon="pi pi-plus" class="p-button-primary" @click="onAddSAPNo" :disabled="hasOrder"/>
                </div>

                <Message severity="error" :closable="true" v-if="addSAPNoMessage" @close="closeAddSAPMessage">{{addSAPNoMessage}}</Message>

                <TabView v-if="sapOrders" >
                    <TabPanel v-for="order in sapOrders" :key="order.Id" :header="order.Document_No + (order.Item_No ? '/' + order.Item_No : '')">
                        <ScrollPanel style="width:100%;height:70vh">
                            <ModalDataSAPOrder :data="order" v-if="order"/>
                        </ScrollPanel>
                    </TabPanel>
                </TabView>                
            </div>
            <Divider layout="vertical" />
            <div class="col-9 md-9 p-fluid">
                <ScrollPanel style="width:100%;height: 80vh">
                    <div class="grid">
                        <div class="col-12">
                            <div class="col-offset-11">
                                <Button label="Sync" class="p-button-help mr-2" @click="syncDOSAP"/>
                            </div>
                        </div>
                    </div>
                    <DataTable :value="details ? details : null" class="p-datatable-sm " responsiveLayout="scroll" >
                        <Column field="include_merge"  key="include_merge">  
                            <template #body="slotProps">
                                <Checkbox v-model="slotProps.data.include_merge" :binary="true"  :disabled="itemEditable(slotProps)" @change="onCheckChanged(slotProps.index)"/>
                            </template>
                        </Column>
                        <Column field="sap_no" :header="$t('sap_no')"></Column>
                        <Column field="Item_No" :header="$t('item_no')" key="Item_No">  
                        </Column>
                        <Column field="Charge_OA_Company" :header="$t('charge_oa_company')" key="Item_No" style="width:10%"></Column>
                        <Column field="LN_Type" :header="$t('ln_type')" key="Item_No" style="width:10%">
                            <template #body="slotProps">
                                <InputText class="p-inputtext-sm" v-model="slotProps.data.LN_Type"  :disabled="slotProps.data.disable_ln_type"/>
                            </template>
                        </Column>
                        <Column field="Incoterm_Rule" :header="$t('incoterm_rule')" key="Item_No" style="width:10%">
                            <template #body="slotProps">
                                <CustomSelect class="p-inputtext-sm" v-model="slotProps.data.Incoterm_Rule" :url="this.$API_URL + 'list/incoterm_rule'" :minLength="0" :params="{ ln_type: slotProps.data.LN_Type }" :filter="true" :disabled="!slotProps.data.require_ln_inco_rule"/>
                            </template>
                        </Column>
                        <Column field="Material_Name" header="Material" key="material_name" style="width:20rem!important">
                            <template #body="slotProps">
                                <div style="text-overflow:ellipsis" class="overflow-hidden white-space-nowrap w-20rem" v-tooltip.top="slotProps.data.Material_Name" type="text" >
                                    {{slotProps.data.Material_Name}}
                                </div>
                            </template>
                        </Column>
                        <Column field="Qty" :header="$t('qty')" key="Active" style="min-width:10rem!important">
                            <template #body="slotProps">
                                <InputNumber v-model="slotProps.data['Qty']" @blur-data="onChangeQty($event, slotProps.index)" :autoChangeMax="false" :max="maxAdjustQty(slotProps)" class="w-10rem"/>
                            </template>
                        </Column>
                        <Column field="order_qty" :header="$t('order_qty')" key="Active" class="w-1">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="sap_os_qty" :header="$t('sap_order_os_qty')" key="Active" class="w-1">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                         <Column field="real_qty" :header="$t('real_qty')" key="Active" class="w-1">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="UOM" header="UOM" key="Active" class="w-1">
                        </Column>
                         <Column field="SO_Factory_No" :header="$t('so_factory_no')" v-if="useDO ||useSO" >
                            <template #body="slotProps">
                                <InputText name="SO_Factory_No" v-model="slotProps.data.SO_Factory_No" type="text" @change="setRequireSync();" class="w-10rem"/>
                            </template>
                        </Column>
                        <Column field="SO_Factory_Item_No" :header="$t('so_factory_item_no')" v-if="useDO || useSO">
                            <template #body="slotProps">
                                <InputText name="SO_Factory_Item_No" v-model="slotProps.data.SO_Factory_Item_No" type="text" @change="setRequireSync();" class="w-5rem"  modelValue=""/>
                            </template>
                        </Column>
                        <Column field="so_factory_result" :header="$t('result')" v-if="(useDO || useSO)" class="w-1">
                        </Column>
                        <Column field="so_factory_result_reason" :header="$t('remarks')" v-if="(useDO || useSO)" class="w-1">    
                        </Column>
                        <Column field="PO_SO_Factory" :header="$t('po_so_factory')" v-if="useDO || useSO" class="w-1">    
                        </Column>
                    </DataTable>

                    <Divider />

                    <div class="grid">
                        <div class="col-6">
                            <FormField :labelName="$t('loading')" fieldName="Order_Type" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                                <CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_from_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" :disabled="true"/>
                            </FormField>

                            <FormField :labelName="$t('stuffing_date')" fieldName="Stuffing_Date" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                                <DatePicker dateFormat="dd/mm/yy" class="p-inputtext-sm" v-model="assignModel.stuffing_date" selectionMode="range" v-if="assignModel" :disabled="true"/>
                            </FormField>

                            <FormField :labelName="$t('charge_oa_company')" fieldName="Charge_OA_Company" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                                <CustomSelect class="p-inputtext-sm" v-model="assignModel.charge_oa_company" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" :disabled="true"/>
                            </FormField>

                            <!-- <div v-if="phase2">
                                <FormField :labelName="$t('ln_type')" fieldName="ln_type" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                                    <InputText class="p-inputtext-sm" v-model="assignModel.ln_type" v-if="assignModel"  :disabled="disableLNType"/>
                                </FormField>

                                <FormField :labelName="$t('incoterm_rule')" fieldName="ln_inco_rule" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                                    <CustomSelect class="p-inputtext-sm" v-model="assignModel.ln_inco_rule" :url="this.$API_URL + 'list/incoterm_rule'" :minLength="0" :params="{ ln_type: assignModel.ln_type }" v-if="assignModel" :filter="true" :disabled="!requireLNIncoRule"/>
                                </FormField>
                            </div> -->
                        </div>
                        <div class="col-6">
                            <FormField :labelName="$t('destination')" fieldName="Loading_Destination_To_Id" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                                <CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_to_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" :disabled="true" />
                            </FormField>
                            
                            <FormField :labelName="$t('freight_date')" fieldName="Freight_Date" v-model="assignModel" fieldClass="col-8" labelClass="col-4" v-if="!isRelation">
                                <DatePicker :placeholder="$t('freight_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="assignModel" v-model="assignModel.freight_date" :disabled="true" />
                            </FormField>

                            <div class="field grid">
                                <label for="Transporter_Notes" class="col-4 p-p-4">{{ isRelation ? $t('customer_vendor_notes') : $t('transporter_notes')}}</label>
                                <div class="col-8 md-8">
                                    <Textarea class="p-inputtext-sm" v-model="assignModel.transporter_notes" :autoResize="true" rows="3" cols="30" v-if="assignModel" />
                                    <Skeleton v-if="!assignModel" />
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div>
                        <div class="field grid">
                            <label for="Transporter_Code" class="col-2 p-p-2">{{ isRelation ? $t('customer_vendor') : $t('transporter')}}</label>
                            <div class="col-4 md-4">
                                <div class="p-inputgroup" v-if="transporters.length > 0">
                                    <InputText name="Transporter_Code" type="text" disabled v-model="transporters[0].transporter_name"/>
                                    <Button icon="pi pi-ellipsis-h" class="p-button p-button-sm" :disabled="true"/>
                                </div>
                                <Skeleton v-if="!(transporters.length > 0)" />
                            </div>
                        </div>
                        <div class="field grid">
                            <label for="Truck_Type_Id" class="col-2">{{$t('truck_type')}}</label>
                            <div class="col-4 md-4">
                                <CustomSelect class="p-inputtext-sm" v-model="transporters[0].truck_type_id" :url="this.$API_URL + 'list/truck_type'" :minLength="0" :params="{ }" v-if="transporters.length > 0" disabled />
                                <Skeleton v-if="!(transporters.length > 0)" />
                            </div>
                        </div>
                        <div class="field grid">
                            <label for="Freight_Cost" class="col-2">{{$t('freight_cost')}}</label>
                            <div class="col-4 md-4">
                                <InputNumber name="Freight_Cost" mode="decimal" :optionalDecimal="true" v-model="transporters[0].freight_cost" v-if="transporters.length > 0"  :disabled="true"/>
                                <Skeleton v-if="!(transporters.length > 0)" />
                            </div>
                            
                            <label for="Freight_Cost" class="col-2">{{$t('freight_total_cost_user_not')}}</label>
                            <div class="col-4 md-4">
                                <InputNumber name="Freight_Total_Cost_User_NoT" mode="decimal" :optionalDecimal="true" disabled v-model="transporters[0].freight_total_cost_user_not" v-if="transporters.length > 0"/>
                                <Skeleton v-if="!(transporters.length > 0)" />
                            </div>
                        </div>
                        <div class="field grid" v-if="!isRelation">
                            <label for="Freight_Container" class="col-2">{{$t('user_num_trip')}}</label>
                            <div class="col-4 md-4">
                                <div class="p-inputgroup">
                                <InputNumber name="Freight_Container" mode="decimal" :optionalDecimal="true" disabled v-model="transporters[0].freight_container" v-if="transporters.length > 0"/>
                                    <span class="p-inputgroup-addon" v-if="transporters.length > 0" style="padding-left:2rem; padding-right:2rem;">{{transporters[0].freight_uom}}</span>
                                </div>
                                
                                <Skeleton v-if="!(transporters.length > 0)" />
                            </div>
                            
                            <label for="Freight_Master" class="col-2">{{$t('freight_master')}}</label>
                            <div class="col-4 md-4">
                                <InputText name="Freight_Master" type="text" disabled v-model="transporters[0].freight_master" v-if="transporters.length > 0" />
                                <Skeleton v-if="!(transporters.length > 0)" />
                            </div>
                        </div>
                        <div class="field grid" v-if="!isRelation">
                            <label for="Assign_Reason" class="col-2">{{$t('reason')}}</label>
                            <div class="col-4 md-4">
                                <CustomSelect class="p-inputtext-sm" v-model="transporters[0].assign_reason" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.ASSIGN_TRANSPORTER_REASON }" v-if="transporters.length > 0" :disabled="true" />
                                <Skeleton v-if="!(transporters.length > 0)" />
                            </div>
                        </div>
                        <div class="field grid" v-if="!isRelation">
                            <label for="Assign_Reason_Others" class="col-2">&nbsp;</label>
                            <div class="col-4 md-4">
                                <Textarea :autoResize="true" rows="5" v-if="transporters.length > 0" v-model="transporters[0].assign_reason_others" :disabled="true" />
                                <Skeleton v-if="!(transporters.length > 0)" />
                            </div>
                        </div>
                    </div>

                </ScrollPanel>
            </div>
        </div>
    </CustomSidebar>    
</template>
<script>
    import ModalDataSAPOrder from '../Helper/_ModalDataSAPOrder.vue'
    import AssignTransporter from '../SAPOrder/_AssignTransporter.vue'

    export default{
        components: {
            'ModalDataSAPOrder': ModalDataSAPOrder,
            'AssignTransporter': AssignTransporter
        },
        emits:['close', 'block', 'unblock'],
        props:{
            data: {
                type: Array,
                default: []
            },
            dataRelation:{
                type: Boolean,
                default:null
            }
        },
        data(){
            return{
                showMergeModal: false,
                orderData: null,
                sapOrders: [],
                details: [],
                dataUrl: "saporder/",
                dataUrlOrder: "order/",
                blocked:false,
                addSAPNo: [],
                addSAPNoMessage: "",
                assignModel: null,
                orderType: "",
                warehouseCode: "",
                incoterm:"",
                shipmentType: "",
                documentType: "",
                transporterCode: "",
                isFirst: true,
                freightDate: null,
                showTransporterModal: false,
                isIndividual: false,
                isCollective: false,
                isRelation: this.dataRelation,
                transporters: [],
                transportersList: [],
                sapTransporter: false,
                selectTransporterNumTrip: 1,
                stuffingDate: [],
                orderLinkSTO: false,    
                estateLocationId: null,
                incoterm2DestinationId: null,
                hasOrder: false,
                excludeTransporters: "",
                blockLoading: false,
                blockDestination: false,
                useLN: false,
                header: null,

                phase2: false,
                requireLNIncoRule: false,
                
                useDO: false,
                useSO: false,
                orderTypeData: null,
                requireSync: false,
                syncSAPSuccess: false,

                disableLNType: true,
            }
        },
        mounted(){
            
        },
        methods:{
            reset(){
                this.orderData = null;
                this.sapOrders = [];
                this.sapOrdersDetail = [];
                this.addSAPNo = [];
                this.addSAPNoMessage= "";
                this.orderType = "";
                this.companyCode = "";
                this.warehouseCode = "";
                this.shipmentType = "";
                this.documentType = "";
                this.isFirst = true;
                this.useLN = false;
                this.useSTO = false;
                this.relationTransporter = "";

                this.details = [];
                this.transporters = [];
                this.transportersList = [];
                this.estateLocationId = null;
                this.incoterm2DestinationId = null;

                this.hasOrder = false;
                this.excludeTransporters = "";
            },
            blockModal(){
                this.blocked = true;
            },
            unblockModal(){
                this.blocked = false;
            },
            onShowMergeModal(){
                this.reset();
            
                this.blocked = false;
                this.showMergeModal = true;

                //Split SAP Order
                var sapNumbers = this.data[0].SAP_No.split('\n');
                this.addSAPNo = sapNumbers;
                this.onAddSAPNo();

                this.getOrderData();
            },
            closeAddSAPMessage(event){
                this.addSAPNoMessage = "";
            },
            showError(summary, message) {
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            save(){
                var data = {
                    order_id: this.data[0].Id,
                    transporter_notes: this.assignModel.transporter_notes,
                    ln_inco_rule: this.assignModel.ln_inco_rule,
                    ln_type: this.assignModel.ln_type,
                    details: this.details,
                    transporter_model: this.transporters[0]
                };
                var self = this;

                if((this.useDO || this.useSO) && this.requireSync){
                    if(!this.syncSAPSuccess)
                    {
                        self.showError('Error Saving Data', 'NOT OK');
                        return;
                    }
                }

                this.blocked = true;

                this.$axios.put(this.$API_URL + this.dataUrlOrder + "edit", data)
                    .then((response) =>{
                        if (response.data.success) {
                            self.$emit('close');
                            self.$parent.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 120000});
                            self.showModal = false;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        self.blocked = false;
                    })
                    .catch((err) => {
                        //console.log(err);
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        self.showModal = false;
                    });
            },
            disableQtyInput(event){
                return this.isCollective || this.useLN; //|| (!event.data.collective_ln && this.orderType == "LN");
            },
            getOrderData(){
                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrlOrder + this.data[0].Id + "/" + this.$FORM_MODE_EDIT )
                    .then((response) => {
                        if(response){
                            if(response.data.success){
                                self.assignModel = response.data.data.assign;
                                var order = response.data.data.header;

                                self.header = order;

                                self.assignModel.loading_destination_from_id = order.Loading_Destination_From_Id;
                                self.assignModel.loading_destination_to_id = order.Loading_Destination_To_Id;
                                self.assignModel.charge_oa_company = order.Charge_OA_Company;
                                self.assignModel.transporter_notes = order.Transporter_Notes;

                                self.disableLNType = order.disable_ln_type;

                                self.phase2 = order.phase2;
                                self.requireLNIncoRule = order.require_ln_inco_rule;

                                self.assignModel.ln_type = order.LN_Type;
                                self.assignModel.ln_inco_rule = order.LN_Inco_Rule;
                                
                                var stuffingDate = [];
                                stuffingDate.push(new Date(order.Stuffing_Date_From));
                                stuffingDate.push(new Date(order.Stuffing_Date_To));
                                self.assignModel.stuffing_date = stuffingDate;

                                self.assignModel.freight_date = new Date(order.Freight_Date);

                                var transporter = {
                                    transporter_code: order.Transporter_Code,
                                    transporter_name: order.Transporter_Name,
                                    truck_type_id: order.Truck_Type_Id,
                                    freight_total_cost_user_not: order.Freight_Total_Cost_User_NoT,
                                    freight_cost: order.Freight_Cost,
                                    freight_container: order.User_NoT,
                                    system_not: order.System_NoT,
                                    user_not: order.User_NoT,
                                    freight_per: order.Freight_Per,
                                    assign_reason: order.Assign_Reason,
                                    assign_reason_others: order.Assign_Reason_Others,
                                    freight_suggested: order.Freight_Suggested,
                                    freight_value: order.Freight_Cost_Value,
                                    freight_uom: order.Freight_Cost_UOM,
                                    freight_master: order.freight_master,
                                    truck_rental: order.Truck_Rental
                                };

                                self.companyCode = order.Company_Code;
                                self.warehouseCode = order.Warehouse_Code;
                                self.shipmentType = order.Shipment_Type;
                                self.documentType = order.Document_Type;
                                self.orderType = order.Order_Type.Code;
                                self.incoterm = order.Incoterm_Name;

                                self.transporters.push(transporter);
                            }
                            else{
                                
                            }
                        }
                    })
                    .catch(function(err){

                    })
            },
            onAddSAPNo(){
                this.blocked = true;

                var data = {
                    order_id: this.data[0].Id,
                    sap_no: this.addSAPNo,
                    warehouse_code: this.warehouseCode,
                    company_code: this.companyCode,
                    incoterm: this.incoterm,
                    order_type: this.orderType,
                    shipment_type: this.shipmentType,
                    document_type: this.documentType,
                    transporter_code: this.transporterCode,
                    is_first: this.isFirst,
                    is_edit: true,
                };

                var self = this;

                //1233000001136, 1233000001133

                this.$axios.post(this.$API_URL + this.dataUrlOrder + "edit_merge_simulate", data)
                    .then((response) => {
                        if (response.data.success) {
                            self.sapOrders = response.data.data.sap_orders;
                            self.details = response.data.data.details;
                            // self.incoterm2DestinationId = response.data.data.incoterm2_destination_id;
                            // self.estateLocationId = response.data.data.estate_location_id;
                            // self.hasOrder = response.data.data.has_order;
                            self.useLN = response.data.data.use_ln;

                            self.orderTypeData = response.data.data.order_type;
                            if(self.orderTypeData){
                                self.useDO = self.orderTypeData.Use_DO;
                                self.useSO = self.orderTypeData.Use_SO;
                            }


                            if(response.data.data.error_message){
                                self.addSAPNoMessage = response.data.data.error_message;
                            }

                            if(self.isFirst){
                                self.isFirst = false;
                            }
                            else{
                                this.changeQty();
                            }
                            
                        }
                        else {
                            self.addSAPNoMessage = response.data.message;
                            //self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        //console.log(err);
                        self.addSAPNoMessage = err;
                        //self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });
            },
            onChangeQty(event, index){
                var model = this.details[index];
                model.Qty = event.valueNumber;
                this.$nextTick(() => {
                    this.changeQty();

                });
            },
            onCheckChanged(index){
                if(this.details.length > 0){
                    var checkedCount = this.details.filter(w => w.include_merge)
                    if(checkedCount.length == 0){
                        this.details[index].include_merge = true;
                    }
                }
            },
            itemEditable(event){
                return !event.data.editable;
            },
            changeQty(){
                this.blocked = true;

                var self = this;

                var data = {
                    order_id: this.data[0].Id,
                    details: this.details
                };

                this.$axios.post(this.$API_URL + "util/refresh_freight_cost_order", data)
                    .then((response) => {
                        if(response){
                            var data = response.data.data;

                            var model = this.transporters[0];
                            // model.transporter_name = data.transporter_name;
                            // model.transporter_code = data.transporter_code;
                            // model.freight_cost = data.cost;
                            // //model.freight_suggested = data.cost;
                            // model.freight_value = data.is_value;
                            // model.freight_per = data.per;
                            // model.truck_type_id = data.truck_type_id;
                            // model.freight_uom = data.is_value ? data.numtrip : data.uom;
                            model.freight_total_cost_user_not = data.total_cost_user_not;
                            model.freight_total_cost = data.total_cost;
                            // model.freight_master = data.master_cost;
                            // model.truck_capacity = data.freight_capacity;
                            // model.freight_kg = data.total_kg_user;
                            // model.system_not = data.system_not;
                            model.freight_material = data.materials;
                            // var container = this.selectTransporterNumTrip;
                            // model.freight_container = container;
                        }
                        self.blocked = false;
                    })
                    .catch(function (err) {
                        self.$showToast({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                    });
            },
            maxAdjustQty(event){
                var qty = event.data.Qty;
                var osQty = event.data.order_qty;
                var sapOSQty = event.data.sap_os_qty;
                var realQty = event.data.real_qty;
                var toleranceQty = event.data.tolerance_qty;

                return parseFloat(osQty) + parseFloat(sapOSQty) + parseFloat(toleranceQty);
            },
             setRequireSync(){
                this.requireSync = true;
            },
            syncDOSAP(){
                var self = this;

                this.blocked = true;

                this.header.Details = this.details;

                 this.$axios.post(this.$API_URL + this.dataUrlOrder  + "sync_do_sap", this.header)
                    .then((response) => {
                        if(response){
                            if(response.data.data){
                                var data = response.data.data;
                                self.details = data;
                                if(response.data.success)
                                    self.requireSync = false;
                            }

                            self.syncSAPSuccess = response.data.success;
                            if(self.syncSAPSuccess == false){
                                self.showError('Error Sync to SAP', response.data.message);
                                self.requireSync = true;
                            }
                        }

                        self.blocked = false;
                    })
                    .catch((error) => {
                        self.showError('Error Sync to SAP', error);

                        self.blocked = false;
                    });
            }
        },
        computed:{
            materialDataModel(){
                var model = [];

                for(var i =0; i< this.sapOrdersDetail.length;i++){
                    var detail = this.sapOrdersDetail[i];
                    model.push({
                        Id: detail.Id,
                        Item_No: detail.Item_No,
                        Material_Code: detail.Material_Code,
                        Material_Name: "",
                        Qty: detail.Qty,
                        UOM: detail.UOM,
                        Freight_Master: 0,
                        Freight_Cost:0,
                        Freight_Per: "",
                        Freight_UOM:""
                    });
                }

                return model;
            },
            orderList(){
                var list = [];

                if(this.sapOrders.length == 0) return list;

                return this.sapOrders.map(function(v) {
                            return v.Id;
                        });
            },
            editTitle(){
                return this.$t('edit_order') + " (" + this.data[0].Order_No + ")";
            }
        }


    }

</script>

